import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private activeRequests = 0;
  isLoading = new Subject<boolean>();

  show() {
    this.activeRequests++;
    this.isLoading.next(true);
  }

  hide() {
    this.activeRequests--;
    if(this.activeRequests == 0){
        this.isLoading.next(false);
    }
  }
}
